import {PaletteColorsEnum} from '../../../../../libs/shared/core/src/models/api/paletteModel';
import {IconName} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {AvailabilityStatusTypesEnum} from '../../../../store/data/teammates/availabilityStatusSelectors';

/*
 * Constants.
 */

const availabilityColors: {[key in AvailabilityStatusTypesEnum]: PaletteColorsEnum} = {
  [AvailabilityStatusTypesEnum.DEFAULT]: PaletteColorsEnum.GREEN,
  [AvailabilityStatusTypesEnum.OUT_OF_OFFICE]: PaletteColorsEnum.RED,
  [AvailabilityStatusTypesEnum.MUTED]: PaletteColorsEnum.ORANGE,
  [AvailabilityStatusTypesEnum.DO_NOT_DISTURB]: PaletteColorsEnum.ORANGE,
};

const availabilityIcons: {[key in AvailabilityStatusTypesEnum]: IconName} = {
  [AvailabilityStatusTypesEnum.DEFAULT]: 'bellSmall',
  [AvailabilityStatusTypesEnum.OUT_OF_OFFICE]: 'bellCrossedSmall',
  [AvailabilityStatusTypesEnum.MUTED]: 'moonFilledSmall',
  [AvailabilityStatusTypesEnum.DO_NOT_DISTURB]: 'donotdisturbSmall',
};

/*
 * API.
 */

export function findTeammateAvailabilityColor(availabilityStatus: AvailabilityStatusTypesEnum) {
  return availabilityColors[availabilityStatus];
}

export function findTeammateAvailabilityIcon(availabilityStatus: AvailabilityStatusTypesEnum) {
  return availabilityIcons[availabilityStatus];
}
